import React from 'react'
import { RiCheckboxBlankCircleLine, RiCheckboxCircleFill } from 'react-icons/ri'

type SingleSelectProps = {
  options: string[]
  value: string | null
  onChange: (value: string | null) => void
  wrapStyle?: React.CSSProperties
  disabled?: boolean
}

export const SingleSelect = ({
  options,
  value,
  onChange,
  wrapStyle,
  disabled = false,
}: SingleSelectProps) => {
  const visibleOptions = disabled
    ? options.filter(option => option === value)
    : options

  return (
    <div
      className="multi-select list-group"
      style={{ minWidth: '20em', ...wrapStyle }}
      aria-disabled={disabled || undefined}
    >
      {visibleOptions.map((type) => {
        const selected = value === type
        return (
          <div
            key={type}
            className={['list-group-item p-2', disabled ? 'disabled' : ''].filter(Boolean).join(' ')}
            aria-disabled={disabled || undefined}
            onClick={() => {
              if (disabled) return
              onChange(selected ? null : type)
            }}
          >
            <div className="chk-cont me-2">
              {selected ? (
                <RiCheckboxCircleFill color="green" size={20} />
              ) : (
                <RiCheckboxBlankCircleLine color="#aaa" size={20} />
              )}
            </div>
            <span>{type}</span>
          </div>
        )
      })}
    </div>
  )
}